import { ILoadFileRequestParams } from '../../file-download';
import { baseLoadFileRequest } from '../../file-download/baseLoadFileRequest';
import { loadRemoteEntity } from './loadRemoteEntity';

export async function loadRawRemoteFile(
  url: string,
  params: ILoadFileRequestParams = {}
): Promise<Response> {
  return await loadRemoteEntity(url, params, baseLoadFileRequest);
}
